import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./routes/Routes";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "react-loading-skeleton/dist/skeleton.css";
import ReactGA from 'react-ga4';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID);

const queryClient = new QueryClient();

const AppWrapper = () => {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar={false}
            closeOnClick
          />
          <RouterProvider router={AppRoutes()} /> 
        </PersistGate>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
};

export default AppWrapper;
